<template lang="html">

  <section class="wrapper cv-area">

    <div class="container">

      <h2 class="title-section">
        <span @click="showEdit">Datos académicos</span>
        <template v-if="isAlumni">
        <button @click="showedit = true" class="cv-action-button edit" v-if="!showedit"></button>
        <button @click="showedit = false" class="cv-action-button close" v-else>✕</button>
        </template>
      </h2>

      <h3 class="subtitle-section" v-if="isAlumni">Estudios cursados en UFV</h3>

      <div class="contenedor-experiencias" v-if="!showedit">
        <academico :data="academico" :key="key" v-for="(academico,key) in cvacademicos" v-if="!!cvacademicos"></academico>
        <p v-if="isEstudiante & !!!cvacademicos" class="zero-results">Sin datos académicos en curso en UFV, por favor contacta con nosotros <router-link :to="$t('enlaces.contacto')">aquí</router-link>.</p>
        <p v-if="isAlumni & !!!cvacademicos" class="zero-results">No tienes ningún dato académico realizado en UFV añadido pulsa <a @click="showedit = true">editar</a> para añadirlo</p>
        <p v-if="noedit & !!!cvacademicos" class="zero-results">Sin datos académicos añadidos</p>
      </div>

      <div class="contenedor-experiencias" v-if="showedit">

        <academico-edit @erase="eraseacademico" v-model="academicoedit[key]" :propio="true" :data="academico" :key="key+'edit'" v-for="(academico,key) in cvacademicos" :clicked="true"></academico-edit>

        <academico-edit :propio="true" :clicked="clicked" @erase="eraseNewacademico" v-model="newacademicos[el-1]" v-if="newacademicoslength != 0" :key="key+'new'" v-for="(el,key) in newacademicoslength"></academico-edit>

        <button v-if="!shownew" @click="newacademicoslength++" class="add-btn
              -newexperiencia">Añadir nuevo</button>
      </div>
      
    </div>
    
    <otros-estudios v-if="isAlumni & !noedit" ref="otrosEstudios" :cvacademicos="cvotrosestudios" :showedit="showedit"></otros-estudios>
    
    <div class="container">

      <button class="btn" v-if="showedit" @click="saveData" :loading="loading">Guardar</button>

    </div>

  </section>

</template>

<script lang="js">

  import academico from '@/components/parts/academico-el';
  import academicoedit from '@/components/parts/academico-edit';

  import otrosEstudios from "@/components/view-parts/espacio-personal/otros-estudios";

  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'datos-academicos',
    props : ['cvacademicos','cvotrosestudios','noedit'],
    data() {
      return {
        showedit: false,
        shownew : false,
        clicked : false,
        newacademicos : [],
        newacademicoslength : 0,
        academicoedit : [],
        loading: false,
      }
    },
    computed : {
      ...mapGetters({
        isEstudiante : 'isEstudiante',
        isAlumni : 'isAlumni',
       
      })
    },
    components: {
      'academico': academico,
      'academico-edit': academicoedit,
      'otros-estudios' : otrosEstudios
    },
    methods: {
      ...mapActions(['editAcademico','requestCV']),
      showEdit(){
        if(!!this.isAlumni){
          this.showedit = !this.showedit;
        }
      },
      eraseacademico(value){
        this.academicosedit = (!!this.cvacademicos) ? this.cvacademicos : [];
        this.showedit = false;
      },
      eraseNewacademico(value){
        this.newacademicos = this.newacademicos.filter(e => e.idTitulacion != value.idTitulacion);
        this.newacademicoslength--;
      },
      saveData(){

          this.clicked = true;

          if(this.academicoedit.every(e => e.allok)  &  this.newacademicos.every(e => e.allok)){

            this.academicoedit = this.academicoedit.concat(this.newacademicos);

            if(this.academicoedit.length != 0){

              this.loading = true;

              this.academicoedit.forEach((e,key) => {
                this.editAcademico(e).then(r => {
                  if(key+1 == this.academicoedit.length){
                    this.showedit = false;
                    this.shownew = false;
                    this.loading = false;
                    this.newacademicos = [];
                    this.newacademicoslength = 0;
                    this.clicked = false;
                    this.requestCV();
                  }
                })
              });

            }

          }else{
            this.clicked = true;
            this.loadingExperiencia = false;
          }

          this.$refs.otrosEstudios.saveData();

      }
    },
    watch : {
      'showedit'(){
        this.academicoedit = (!!this.cvacademicos) ? this.cvacademicos : [];
      },
      'cvacademicos': {
          deep: true,
          handler(){
            this.academicoedit = (!!this.cvacademicos) ? this.cvacademicos : [];
          }
      }
    }
  }
</script>

<style scoped lang="scss">

  .add-btn{
    margin-bottom: 25px;
  }

  p:last-child, p:last-of-type {
    margin-bottom: 15px;
}

</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/datos-academicos.vue